
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#EEF1FE',
            100: '#DDE3FD',
            200: '#BBC7FB',
            300: '#99ABF9',
            400: '#778FF7',
            500: '#5B7CF6',
            600: '#4963C5',
            700: '#374A94',
            800: '#253162',
            900: '#121831',
            950: '#0B0F1E'
        },
    },
    components: {
        button: {
            colorScheme: {
                info: {
                        background: '#007CFF',
                        hoverBackground: '#007CFF',
                        activeBackground: '#006CFF',
                    }
                }
            }
        }
    }
);